module.exports = __webpack_public_path__ + "img/banner.4e761147.jpg";